// src/telemetry/TelemetryProvider.tsx

import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';

import {
    useLocation,
} from 'react-router-dom';

import {
    TelemetryRegistry,
} from './TelemetryRegistry';

import {
    useTrackPage,
} from './hooks/useTrackPage';

import {
    telemetryManager,
} from './TelemetryManager';

export default function
    TelemetryProvider({
        children,
    }: PropsWithChildren) {

    const location =
        useLocation();

    const routePath =
        `${location.pathname}${location.search}${location.hash}`;

    const destination =
        TelemetryRegistry.resolve(
            location.pathname,
            location.search,
            location.hash
        );

    useTrackPage({

        moduleName:
            destination.module,

        submoduleName:
            destination.submodule,

        routePath,

    });


    useEffect(() => {

        // TODO/DEPRECATED: Heartbeat polling is deprecated to avoid unnecessary network traffic and align with event-driven telemetry.
        /*
        const heartbeatInterval =
            setInterval(() => {

                const focus =
                    telemetryManager.getFocus();

                if (!focus)
                    return;

                telemetryManager.track({

                    moduleName:
                        focus.moduleName,

                    submoduleName:
                        focus.submoduleName,

                    routePath:
                        focus.routePath,

                    eventType:
                        'heartbeat',

                    actionType:
                        'heartbeat_pulse',

                    actionLabel:
                        'heartbeat',

                });

            }, 30000);
        */

        // TODO/DEPRECATED: Batch flushing interval timer is deprecated. Telemetry is sent immediately per event.
        /*
        const flushInterval =
            setInterval(
                () => {
                    telemetryManager.flush();
                },
                30000
            );
        */

        const handleGlobalClick = (event: MouseEvent) => {
            const target = (event.target as HTMLElement).closest('[data-telemetry-action]');
            if (!target) return;

            const actionType = target.getAttribute('data-telemetry-action');
            const actionLabel = target.getAttribute('data-telemetry-label') || 'User Click';
            const rawMetadata = target.getAttribute('data-telemetry-metadata');
            
            let metadata = {};
            if (rawMetadata) {
                try {
                    metadata = JSON.parse(rawMetadata);
                } catch (e) {
                    console.warn('[Telemetry Interceptor] Failed to parse metadata:', e);
                }
            }

            if (actionType) {
                telemetryManager.track({
                    moduleName: 'Global',
                    submoduleName: 'Interactive Element',
                    eventType: 'action',
                    actionType: actionType as any,
                    actionLabel,
                    metadata,
                });
            }
        };

        const handleUnload =
            () => {

                telemetryManager.unload();

            };

        document.addEventListener('click', handleGlobalClick);

        window.addEventListener(
            'beforeunload',
            handleUnload
        );

        return () => {

            /*
            clearInterval(
                heartbeatInterval
            );

            clearInterval(
                flushInterval
            );
            */

            document.removeEventListener('click', handleGlobalClick);

            window.removeEventListener(
                'beforeunload',
                handleUnload
            );

        };

    }, []);

    return <>{children}</>;

}